import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TablePreviewXLSX from '../StepUploadFIleData/TablePreviewXLSX';
import FormFileAttachments from './FormFileDocuments';
const useStyles = makeStyles(({
  container: {
    padding: '40px'
  },
  containerTable: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '16px'
  }
}));
const StepUploadAttachments = ({ data, onChange, setIsValid }) => {
  const [excelData, setExcelData] = useState(data.step2.excelData);
  const headersTable = excelData ? Object.keys(excelData[0]) : [];

  useEffect(() => {
    if (data.step1.auditLevel === 'opened') {
      const isValid = excelData && excelData.every((item) => item.attachmentName);
      setIsValid(isValid);
    }
  }, [excelData]);

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <FormFileAttachments data={data} onChange={onChange} setExcelData={setExcelData} />

      {excelData && <TablePreviewXLSX headers={headersTable} rows={excelData} />}

    </div>

  );
};
StepUploadAttachments.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object
};
export default StepUploadAttachments;
